<template>
  <v-toolbar
    color="#F4FFBA"
    app
    fixed
    flat
    :extended="$store.state.hasMultitenant"
    extension-height="45px"
    class="px-4 pt-4"
  >
    <v-layout
      class="toolbar"
    >
      <v-flex>
        <div
          @click="$router.push('/')"
        >
          <v-img
            :src="require(`../assets/crmlogo.svg`)"
            contain
            max-width="150px"
            min-width="150px"
          />
        </div>
      </v-flex>
      <v-flex class="positionActions">
        <v-layout class="positionActionsColumns mr-3">
          <v-flex class="d-flex">
            <button
              v-if="updateExists"
              icon
              @click="refreshApp"
            >
              <v-icon>refresh</v-icon>
            </button>
            <span>
              <v-menu
                id="menuConfig"
                v-model="showMenu"
                offset-y
                transition="slide-y-transition"
              >
                <template #activator="{ on }">
                  <div v-on="on" />
                </template>
                <v-list dense>
                  <!-- <div
                    v-if="$store.getters.isManager || $store.getters.isDirector"
                  > -->
                  <!-- <v-subheader>GERENCIAL</v-subheader> -->
                  <!-- <v-list-tile
                      to="/gestaocontatos"
                      @click="countGesContato"
                    >
                      <v-list-tile-action class="ml-3">
                        <v-icon
                          color="black"
                          small
                        >fas fa-users-cog</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <h4>Gerenciar Contatos</h4>
                      </v-list-tile-content>
                    </v-list-tile>
                  </div> -->
                  <!-- <v-subheader>PERFIL</v-subheader> -->
                  <v-list-tile
                    v-if="($store.getters.isManager || $store.getters.isDirector) && getCustomer.salesAssistant"
                    to="/solicitacoes"
                  >
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        color="primary"
                        small
                      >
                        mdi-lightning-bolt
                      </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Solicitações</h4>
                      <div
                        v-if="getPendingApprovalRequests.length"
                        class="approval-request-notification"
                      />
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    v-if="$store.state.hasMultitenant && getCustomer.salesAssistant"
                    to="/abandonados"
                  >
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        color="primary"
                        small
                      >mdi-cart-outline</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Carrinhos abandonados</h4>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    v-if="$store.state.hasMultitenant"
                    to="/login/vendedor"
                  >
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        color="primary"
                        small
                      >$vuetify.icons.arrowSwapIcon</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Trocar Loja/Usuário</h4>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    v-if="$store.getters.isManager || $store.getters.isDirector"
                    to="/sellers"
                  >
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        small
                        color="primary"
                      >
                        $vuetify.icons.unionIcon
                      </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Gerenciar Usuários</h4>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile to="/cadastro/editar">
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        small
                        color="primary"
                      >
                        $vuetify.icons.userIcon
                      </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Editar Dados Pessoais</h4>
                    </v-list-tile-content>
                  </v-list-tile>
                  <!-- <v-list-tile
                    @click="
                      openPage('https://sejazipper.zendesk.com/hc/pt-br')
                    "
                  >
                    <v-list-tile-action class="ml-3">
                      <v-icon color="black" small
                        >fas fa-question-circle</v-icon
                      >
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Central de Ajuda</h4>
                    </v-list-tile-content>
                  </v-list-tile> -->
                  <!-- <v-list-tile
                    @click="
                      openPage(
                        'https://sejazipper.zendesk.com/hc/pt-br/requests'
                      )
                    "
                  >
                    <v-list-tile-action class="ml-3">
                      <v-icon color="black" small>fas fa-headset</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Meus Chamados</h4>
                    </v-list-tile-content>
                  </v-list-tile> -->
                  <v-list-tile
                    @click="redirectToWhatsapp"
                  >
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        color="primary"
                        style="font-size: 20px"
                      >
                        mdi-whatsapp
                      </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Precisa de ajuda?</h4>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="countLogout">
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        color="primary"
                        small
                      >$vuetify.icons.signOutIcon</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Sair</h4>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </span>

            <v-flex
              v-if="$store.state.hasMultitenant"
              shrink
            >
              <v-badge
                overlap
                bottom
                class="d-inline"
                color="#FF5146"
                :value="getPendingApprovalRequests.length || !!$auth.user.secondPicture"
              >
                <template #badge>
                  <v-avatar
                    v-if="$auth.user.secondPicture && !getPendingApprovalRequests.length"
                    slot="badge"
                    size="18px"
                  >
                    <v-img :src="$auth.user.secondPicture" />
                  </v-avatar>
                  <span v-if="getPendingApprovalRequests.length">
                    {{ getPendingApprovalRequests.length }}
                  </span>
                </template>

                <v-btn
                  flat
                  icon
                  @click.stop="showMenu = true"
                  @click="countProfile"
                >
                  <v-avatar size="32px">
                    <v-img :src="$auth.user.picture" />
                  </v-avatar>
                </v-btn>
              </v-badge>
            </v-flex>

            <v-flex
              v-if="!$store.state.hasMultitenant"
              shrink
            >
              <v-btn
                flat
                icon
                @click.stop="showMenu = true"
                @click="countProfile"
              >
                <v-avatar size="32px">
                  <v-img :src="$auth.user.picture" />
                </v-avatar>
              </v-btn>
            </v-flex>
          </v-flex>
          <v-flex>
            <h6
              class="px-0 grey--text text-xs-right"
              style="
                font-weight: normal;
                font-size: 6px;
                margin-top: 2px;
              "
            >
              Versão: {{ $store.getters.appVersion }}
            </h6>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <template
      v-if="$store.state.hasMultitenant || getCustomer.salesAssistant"
      #extension
    >
      <div
        v-if="(getCustomer.salesAssistant && getCustomer.stores.length > 1) || sellerStores.length > 1"
        class="mb-3"
      >
        <v-select
          ref="storeSelect"
          v-model="selected"
          class="store-select mb-2"
          :value="getStoreSelected"
          :items="activeStores"
          color="primary"
          item-text="name"
          append-icon="$vuetify.icons.arrowDownIcon"
          return-object
          @change="changeStore"
        >
          <template #selection="{ item }">
            <span> {{ `${getCustomer.name} - ${item.name}` }}</span>
          </template>
          <template #item="props">
            <v-list-tile
              v-bind="props.attrs"
              @click="changeStoreOrOpenDialog(props.item, getCustomer.salesAssistant)"
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ props.item.name }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-select>
      </div>
      <h5
        v-else
        class="profile-txt"
      >
        {{ getCustomer.name }} -
        {{ getStore.name }}
      </h5>
    </template>
    <v-dialog
      v-model="changeStoreDialog"
      persistent
      width="362"
    >
      <ChangeStoreDialog
        :close="() => changeStoreDialog = false"
        :change-store="() => changeStoreOrOpenDialog(storeToChange)"
      />
    </v-dialog>
  </v-toolbar>
</template>

<script>
import axios from 'axios';
import { mapState, mapGetters } from 'vuex';
import { APIService } from '@/resources/campanha.js';
import { useVuexSellerStores } from '@/composables/useVuexSellerStores';
import { useManagerDashboard } from '@/composables/useManagerDashboard';
import { useZipperApi } from '../composables/useZipperApi';

const { client } = useZipperApi();
const api = new APIService();

export default {
  props: {
    source: String,
  },
  setup(props, { root }) {
    const { changeStoreSelected } = useManagerDashboard();
    const { stores: sellerStores, loading } = useVuexSellerStores(root);
    return {
      sellerStores,
      loading,
      changeStoreSelected,
    };
  },
  data() {
    return {
      counterAddLead: 0,
      counterBuscarContato: 0,
      buscarContatoMarca: false,
      counterGestContato: 0,
      counterLogout: 0,
      counterProfile: 0,
      showMenu: false,
      customer: {},
      refreshing: false,
      registration: null,
      updateExists: false,
      selectedStore: [],
      selected: null,
      changeStoreDialog: false,
      storeToChange: null,
    };
  },
  computed: {
    ...mapState(['agendaMarca']),
    ...mapGetters(['getCustomer', 'getStore', 'getPendingApprovalRequests']),
    sellerId() {
      return this.$auth.user.rootSub || this.$auth.user.sub;
    },
    getStoreSelected() {
      if (!this.selected) {
        this.$set(this, 'selected', this.sellerStores[0]);
      }
      this.changeStoreSelected(this.selected);
      this.$store.commit('SET_STORE', this.selected);
      return this.selected;
    },
    activeStores() {
      const stores = this.getCustomer.salesAssistant ? this.getCustomer.stores : this.sellerStores;

      return stores.filter((s) => !s.disabled);
    },
  },
  watch: {
    getStore(value) {
      this.changeStoreSelected(value);
      this.$set(this, 'selected', value);
    },

  },
  created() {
    /* document.addEventListener(
      'swUpdated', this.showRefreshUI, { once: true }
    );
    navigator.serviceWorker.addEventListener(
      'controllerchange', () => {
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload();
      }
    ); */
  },
  methods: {
    redirectToWhatsapp() {
      const text = encodeURI('Olá! Preciso de ajuda.');
      window.open(`https://wa.me/+5511910751953?text=${text}`, '_blank');
    },
    openPage(title) {
      window.open(title);
    },
    downloadOnboarding() {
      axios({
        url:
          'https://konselior.s3.amazonaws.com/onboard/Onboarding+Kontalk.pdf',
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Manual Kontalk.pdf'); // or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    countAddLead() {
      this.counterAddLead += 1;
      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Adicionar Lead',
        eventValue: this.counterAddLead,
      });
    },
    countGesContato() {
      this.counterGestContato += 1;
      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Gestao Contatos',
        eventValue: this.counterGestContato,
      });
    },
    countBuscarContato() {
      this.counterBuscarContato += 1;
      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Buscar Contatos na Marca',
        eventValue: this.counterBuscarContato,
      });
      this.buscarContatoMarca = true;
    },
    async countLogout() {
      this.$store.commit('SET_STORE', null);
      this.counterLogout += 1;
      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Logout',
        eventValue: this.counterLogout,
      });
      this.$auth.logout();
      await this.clearIndexedDB();
    },

    clearIndexedDB() {
      return new Promise((resolve, reject) => {
        const request = window.indexedDB.open('product_catalog', 1);

        request.onupgradeneeded = (event) => {
          this.dbInstance = event.target.result;
          if (!this.dbInstance.objectStoreNames.contains('product_catalog')) {
            this.dbInstance.createObjectStore('product_catalog', { autoIncrement: true });
          }
        };

        request.onsuccess = async (event) => {
          this.dbInstance = event.target.result;

          const transaction = this.dbInstance.transaction(['product_catalog'], 'readwrite');
          const objectStore = transaction.objectStore('product_catalog');

          const clearRequest = objectStore.clear();

          clearRequest.onsuccess = (res) => {
            resolve('Sucesso ao limpar object store', res);
          };

          clearRequest.onerror = (error) => {
            console.error('Erro ao limpar o object store', error);
            reject(new Error('Erro ao limpar o object store'));
          };
        };

        request.onerror = (event) => {
          reject(new Error('Erro no IndexedDB', event));
        };
      });
    },

    countProfile() {
      this.counterProfile += 1;
      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Exibir Perfil',
        eventValue: this.counterProfile,
      });
    },
    sendMessage() {
      location.href = 'http://api.whatsapp.com/send?phone=5548991032835';
    },
    getUser() {
      return this.$auth.user;
    },

    isLoggedIn() {
      return this.$auth.isAuthenticated();
    },

    showRefreshUI(e) {
      this.registration = e.detail;
      this.updateExists = true;
    },

    refreshApp() {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage('skipWaiting');
    },
    changeStore() {
      if (!this.loading) {
        const finalStoreSelected = {
          ...this.selected,
          id: [this.selected.id],
        };
        if (this.selected.alternateIds) finalStoreSelected.id.push(...this.selected.alternateIds);
        this.changeStoreSelected(finalStoreSelected);
        this.$store.commit('SET_STORE', this.selected);
      }

      return [];
    },
    changeStoreOrOpenDialog(store, openDialog) {
      if (openDialog && (store.id !== this.selected.id)) {
        this.storeToChange = store;
        this.changeStoreDialog = true;
      } else {
        this.selected = store;
      }

      this.$refs.storeSelect.blur();
    },
  },
};
</script>

<style scoped>
.toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.positionActions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.positionActionsColumns {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.v-menu__content--fixed {
  top: 58px !important;
  left: 0px !important;
  min-width: 100% !important;
  border-bottom: 2px solid #e0e0e0;
}
.v-menu__content {
  box-shadow: none !important;
}
.v-toolbar__content .v-btn--icon,
.v-toolbar__extension .v-btn--icon {
  margin: 0px !important;
}
::v-deep .v-toolbar__extension {
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.v-toolbar__content {
  display: flex;
  flex-direction: column;
  height: 60px !important;
}

.button-background {
  color: white !important;
}
</style>

<style>
.borda-header {
  border: 1px solid red;
}

.v-chip__close {
  margin: 0px 0px 0px 10px;
}
.v-badge__badge {
  height: 15px;
  width: 15px;
  font-size: 10px;
  font-weight: 700;
}
.v-list__tile__action {
  min-width: 40px;
}

.v-toolbar__content {
  padding: 0;
}

.div.v-toolbar__extension {
  padding-left: 5px;
}
.profile-txt {
  font-family: 'Nunito sans';
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
}

.store-select {
  max-width: 80%;
  height: auto;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #433D4E;
  flex-wrap: nowrap;
}

.approval-request-notification {
  position: absolute;
  right: min(10%, 32px);
  max-width: 14px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #FF5146;
}
</style>
